import Axios from 'axios'
import qs from 'qs'
import router from './router'
import { store, logOut } from './legacyStore'
import { updateSessionTimeout } from './vuex-actions'
import { SESSION_API_PATH } from './components/auth/authConfig'

const instance = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  withCredentials: true,
  headers: { Accept: 'application/json' },
  paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
})

instance.interceptors.response.use(
  (response) => {
    localStorage.removeItem('pdfjs.history')

    if (response && response.status >= 200 && response.status < 300 && store.getters.isLoggedIn) {
      // Register activity and update session timeout on successful API calls
      store.commit(updateSessionTimeout)
    }

    return response
  },
  async (error) => {
    if (error.response) {
      const { status } = error.response
      // on a login screen a 401 is part of the flow (the V2 screens go back to the login start themselves), not a lost session
      // nor is the session read's: authFlow answers it, and on the router's first navigation the current route can't tell a login screen yet
      const isSessionRead = error.config?.method === 'get' && error.config?.url === SESSION_API_PATH
      if (status === 401 && !isSessionRead && !router.currentRoute.value.meta.authScreen) {
        // user is unauthorized, complete logout - this should clear all user data and tokens
        setTimeout(async () => {
          await logOut()
        }, 4000)

        // rejects the state (e.g. throws an error)
        // NOTE: so every axios call's CATCH block is executed just when we have 401 on a non-login page, when we f*** can't do anything and are so-so redirected to the login page after a logout()
        return Promise.reject(error)
      }
    }
    
    // resolves the error...returns the object
    return error.response
  }
)

export default instance
